import DirectoryDetailsSubHeader from './DirectoryDetailsSubHeader'

export default DirectoryDetailsSubHeader
